import { PageContainer, PageHeader } from '../../components/Layout'
import { Card, CardContent, Badge } from '../../components/UI'
import { useRentalTechData } from './useRentalTechData'

const statusVariant = {
  available: 'success',
  rented: 'warning',
  maintenance: 'error'
}

export default function RentalTechAvailability() {
  const { equipments, availability, loading } = useRentalTechData()

  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeader
          title="Disponibilidad Inteligente"
          subtitle="Vista tipo Gantt para validacion de disponibilidad y control anti-overbooking"
        />

        <Card>
          <CardContent className="p-0 overflow-x-auto">
            <table className="w-full text-sm min-w-[850px]">
              <thead className="bg-gray-50 border-b">
                <tr className="text-left">
                  <th className="px-4 py-3">Equipo</th>
                  <th className="px-4 py-3">Estado</th>
                  <th className="px-4 py-3">Bloque Actual</th>
                  <th className="px-4 py-3">Utilizacion Tiempo</th>
                  <th className="px-4 py-3">Utilizacion Financiera</th>
                </tr>
              </thead>
              <tbody>
                {equipments.map((eq) => {
                  const block = availability.find((item) => item.equipment_id === eq.id)
                  return (
                    <tr key={eq.id} className="border-b">
                      <td className="px-4 py-3">
                        <div className="font-medium text-gray-900">{eq.name}</div>
                        <div className="text-xs text-gray-500">{eq.code} - {eq.type}</div>
                      </td>
                      <td className="px-4 py-3"><Badge variant={statusVariant[eq.status] || 'default'}>{eq.status}</Badge></td>
                      <td className="px-4 py-3">
                        {block
                          ? `${new Date(block.start_utc).toLocaleString('es-CO')} -> ${new Date(block.end_utc).toLocaleString('es-CO')}`
                          : 'Sin reserva activa'}
                      </td>
                      <td className="px-4 py-3">{eq.utilization_time_pct || 0}%</td>
                      <td className="px-4 py-3">{eq.utilization_financial_pct || 0}%</td>
                    </tr>
                  )
                })}
                {!equipments.length && (
                  <tr>
                    <td colSpan={5} className="px-4 py-10 text-center text-gray-500">No hay equipos registrados.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardContent>
        </Card>

        {loading ? <p className="text-sm text-gray-500">Actualizando disponibilidad...</p> : null}
      </div>
    </PageContainer>
  )
}
